<template>
    <transition name="slide-y-transition" mode="out-in">
        <div class="table table_middle" v-if="items.length">
            <modal></modal>
            <table>
                <thead>
                <tr>
                    <!--<icon-arrowup/>-->
                    <th class="caption">Имя автора<span class="table_move"></span></th>
                    <th class="middle little">Видимость</th>
                    <th class="icons"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items" v-bind:key="item.id">
                    <router-link :to="`/authors/${item.id}/edit`" class="table-link caption link">
                        <span>{{item.title}}</span>
                    </router-link>
                    <td class="middle little">
                        <v-switch
                            v-model="item.is_active" :color="'#089cd3'"
                            @click.capture.stop="item.is_active = !item.is_active; toggleItem({id: item.id, isActive: item.is_active})">
                        </v-switch>
                    </td>
                    <td class="icons">
                        <router-link :to="`/authors/${item.id}/edit`" class="edit">
                            <icon-pencil/>
                            <div class="hint left edit">Редактировать</div>
                        </router-link>
                        <a class="delete-icon" @click.prevent="onDeleteItem(item)">
                            <icon-delete/>
                            <div class="hint left">Удалить</div>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </transition>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'
  import IconDelete from '@/components/icons/IconDelete'
  import IconArrowup from '@/components/icons/IconArrowup'
  import IconPencil from '@/components/icons/IconPencil'
  import Modal from '@/components/Modal'

  const {mapActions, mapState, mapMutations} = createNamespacedHelpers('mainPage')

  export default {
    computed: {
      faPencilAlt() {
        return faPencilAlt
      },
      faTrash() {
        return faTrash
      },
      faLink() {
        return faLink
      },
      apiDomain() {
        return this.$store.state.apiDomain
      },
      siteUrl() {
        return this.$store.state.siteUrl
      },
      ...mapState([
        'items'
      ]),
    },
    methods: {
      ...mapActions([
        'getItems',
        'toggleItem',
        'onEditItem',
        'deleteItem'
      ]),
      ...mapMutations([
        'setShowModal',
        'setItemForDelete'
      ]),
      onDeleteItem(item) {
        this.setItemForDelete({id: item.id, title: item.title, url: 'contents'});
        this.setShowModal(true);
      }
    },
    components: {
      IconDelete,
      IconPencil,
      IconArrowup,
      Modal
    }
  }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */
    {
        opacity: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/authors/MainTable.vue